import { REQUEST_STATUSES } from "@/constants";
import { getErrorResponse } from "@/utils/helper";

import instance, { api } from "./instance";

export class ElementService {
  static async getElements(propertyId, experienceId, query) {
    try {
      const resp = await instance({
        method: "get",
        url: `/api/v2/elements/${propertyId}/${experienceId}`,
        params: query,
      });

      return {
        resp: resp.data,
        err: null,
        status: REQUEST_STATUSES.SUCCEEDED,
      };
    } catch (err) {
      return {
        resp: { data: [], count: 0 },
        err: getErrorResponse(err),
        status: REQUEST_STATUSES.FAILED,
      };
    }
  }

  static async getElement(propertyId, experienceId, elementId) {
    try {
      const resp = await instance({
        method: "get",
        url: `/api/v2/elements/${propertyId}/${experienceId}/${elementId}`,
      });

      return {
        resp: resp.data,
        err: null,
        status: REQUEST_STATUSES.SUCCEEDED,
      };
    } catch (err) {
      return {
        resp: null,
        err: getErrorResponse(err),
        status: REQUEST_STATUSES.FAILED,
      };
    }
  }

  static async addElement(propertyId, experienceId, data = {}) {
    try {
      const resp = await api({
        method: "post",
        url: `/api/v2/elements/${propertyId}/${experienceId}`,
        data,
      });

      return {
        resp: resp.data,
        err: null,
        status: REQUEST_STATUSES.SUCCEEDED,
      };
    } catch (err) {
      return {
        resp: null,
        err: getErrorResponse(err),
        status: REQUEST_STATUSES.FAILED,
      };
    }
  }

  static async updateElement(propertyId, experienceId, elementId, data) {
    try {
      const resp = await api({
        method: "put",
        url: `/api/v2/elements/${propertyId}/${experienceId}/${elementId}`,
        data,
      });

      return {
        resp: resp.data,
        err: null,
        status: REQUEST_STATUSES.SUCCEEDED,
      };
    } catch (err) {
      return {
        resp: null,
        err: getErrorResponse(err),
        status: REQUEST_STATUSES.FAILED,
      };
    }
  }

  static async deleteElement(propertyId, experienceId, elementId) {
    try {
      const resp = await api({
        method: "delete",
        url: `/api/v2/elements/${propertyId}/${experienceId}/${elementId}`,
      });

      return {
        resp: resp.data,
        err: null,
        status: REQUEST_STATUSES.SUCCEEDED,
      };
    } catch (err) {
      return {
        resp: null,
        err: getErrorResponse(err),
        status: REQUEST_STATUSES.FAILED,
      };
    }
  }
}
